function submitFormMulticardingPreLogin(action,interestedCardCategory,interestedCardType) {
    console.log("interestedCardType", interestedCardType);
		$("#multicardform").append('<form style="position:absolute; left:-1000px;top:-1000px;"action="' + action + '" method="POST" class="multicardform">');
		$("#multicardform form").append('<input type="hidden" name="interestedCardCategory"  id="interestedCardCategory" value="' + interestedCardCategory + '"/>');
		$("#multicardform form").append('<input type="hidden" name="interestedCardType" name="interestedCardType" value="' + interestedCardType + '"/>');
		$("#multicardform form").append('<br><input type="submit" id="savebutton" value="" />');
		$("#multicardform form").submit();
}
